import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import {
  ContentChunkFragment,
  PieceFragment,
  RichTextFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { RichTextRenderer } from '../../tileRenderers/RichTextRenderer';
import ButtonLink from '../../shared/ButtonLink';
import Container from '../../shared/Container';
import FaqQuestion from './components/faq-question/faq-question';

export interface FaqContainerTile {
  title: RichTextFragment;
  questions: ContentChunkFragment;
  cta: PieceFragment;
}

export default function FaqContainer({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: FaqContainerTile;
  trackingPrefix?: string;
}>) {
  const { title } = tile;
  const questions = tile.questions?.chunks;

  return (
    <Container>
      <RichTextRenderer blocks={title} className="text-center text-2xl sm:text-3xl" />
      <div className=" mx-auto mt-8 max-w-7xl divide-y divide-neutral-10 border-b border-t border-neutral-10 sm:mt-12 ">
        {questions?.map((question) => (
          <FaqQuestion
            key={question[0]?.id ?? question[0]?.name}
            question={question}
            trackingPrefix={trackingPrefix}
          />
        ))}
      </div>
      <ButtonLink
        ctaComponent={tile.cta}
        className=" mx-auto mt-8 flex w-fit items-center justify-center gap-1 text-md underline sm:mt-12"
        trackingPrefix={trackingPrefix}
      >
        <ChevronRightIcon className="h-auto w-4 text-primary-100" />
      </ButtonLink>
    </Container>
  );
}
